'use client';
import React from 'react';
import { CallToAction } from 'trimble-terra';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { processLinkUrl } from '@/utils/linkUtils';
import './ArticleCta.css';

export default function ArticleCta(props: { data: any }) {
  const { data } = props;

  const description = data?.description?.json 
    ? documentToReactComponents(data.description.json)
    : null;

  const getPrimaryButton = () => {
    if (!data?.primaryButton) return null;
    const destination = processLinkUrl(data.primaryButton?.destination || data?.primaryButton);
    if (!destination) return null;
    return {
      label: data.primaryButton.textLabel,
      destination,
      primary: data.primaryButton.isPrimary ?? true
    };
  };

  const getSecondaryButton = () => {
    if (!data?.secondaryButton) return null;
    const destination = processLinkUrl(data.secondaryButton?.destination || data?.secondaryButton);
    if (!destination) return null;
    return {
      label: data.secondaryButton.textLabel,
      destination,
      primary: data.secondaryButton.isPrimary ?? false
    };
  };

  const primaryButton = getPrimaryButton();
  const secondaryButton = getSecondaryButton();

  // console.log('brandon data:', primaryButton);
  // console.log('brandon data:', secondaryButton);

  return (
    <div className="article-cta">
      <CallToAction
        description={description}
        primaryButton={primaryButton}
        secondaryButton={secondaryButton}
      />
    </div>
  );
}